import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import 'flatpickr/dist/themes/dark.css';
import React, { useEffect, useRef } from 'react';

export function DateInput({
  value,
  onChange,
  dateFormat = 'Y-m-d',
  className = '',
  ...rest
}) {
  const inputRef = useRef(null);
  const pickerRef = useRef(null);

  useEffect(() => {
    if (!inputRef.current) return;

    pickerRef.current = flatpickr(inputRef.current, {
      dateFormat,
      defaultDate: value || null,
      onChange: (selectedDates) => {
        const selected = selectedDates?.[0] ?? null;
        onChange?.(selected);
      },
    });

    return () => {
      pickerRef.current?.destroy();
      pickerRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (!pickerRef.current) return;
    pickerRef.current.setDate(value || null, false);
  }, [value]);

  return (
    <input
      ref={inputRef}
      className={`input-field__control ${className}`.trim()}
      type="text"
      {...rest}
    />
  );
}
